import { useHeaders } from "hooks/api/useHeaders";
import { useMutation } from "react-query";
import { downloadAssetReq } from "api/assets";

export const useDownloadAsset = () => {
    const headers = useHeaders();

    return useMutation((id: number) => downloadAssetReq(headers, id));
};
